function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.99 1.702L7 7.712l6.01-6.01L11.596.288 7 4.884 2.404.288.99 1.702z"
});
function SvgArrowToBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8
  }, props), _ref);
}
export default SvgArrowToBottom;